<template>
  <transition name="slide-right">
    <div class="flex flex-col fixed pin-y pin-r mt-11 lg:mt-12 px-4 pt-4 w-full lg:w-2/5 bg-white z-1000">
      <HideModalButton :onClickHide="onClickHide" />
      <div class="flex flex-col mt-6" :class="districtNames ? 'mb-2' : ''">
        <div class="text-black text-xl">{{ school.properties.nama }}</div>
        <div class="text-grey-dark text-sm">Kode Zona {{ zone.kode_zonasi }}</div>
        <div class="text-grey-dark text-sm">{{ districtNames }}</div>
        <div class="text-grey-dark text-sm">{{ province.nama }}</div>
      </div>
      <div class="mt-4">
        <button class="bg-success hover:bg-success-dark text-white text-xs font-bold py-1 px-2 rounded" @click="showRecap">
          Tinjau Tabel Kebutuhan
        </button>
      </div>
      <div class="overflow-y-auto h-full p-4 -mx-4 flex flex-col">
        <div v-if="isFetchingStats" class="flex mt-32 mx-auto">
          <v-icon name="spinner" scale="2" pulse class="text-brand" />
        </div>
        <div v-else>
          <course-chart v-show="isDataAvailable" :stats="stats" :on-select="onSelect" />
          <div v-show="!isDataAvailable" class="text-black text-xs p-4">
            -- Data tidak ditemukan --
          </div>
        </div>
        <div v-if="course" class="mt-8 lg:ml-4 ml-2 text-black text-sm">Guru Mata Pelajaran <span class="font-bold">{{ course }}</span></div>
        <div class="mt-2 mb-12 text-black text-sm w-full">
          <div @click="selectTeacher(teacher, index)" :class="{ 'selected-teacher': selectedTeacherIndex === index, 'cursor-pointer': !teacher.isMutation, 'cursor-not-allowed bg-overlay-light': teacher.isMutation }" class="flex items-center justify-between rounded-lg border mt-2" v-for="(teacher, index) in teachers" :key="index">
            <div class="flex p-2 ml-2 items-center">
              <v-icon name="user-circle" scale="2" :class="selectedTeacherIndex === index ? 'text-white' : 'text-profile'" />
              <div class="ml-3">
                {{ teacher.nama }}
              </div>
            </div>
            <a v-if="teacher.token && isLogin" class="flex no-underline flex-no-shrink items-center border rounded-lg py-2 px-4 mr-2 bg-grey-lighter" :href="'http://info.gtk.kemdikbud.go.id/index.php?s=1&data=' + teacher.token" target="_blank">
              <div class="text-grey-darkest text-xs font-bold mr-1">Info GTK</div>
              <v-icon name="external-link-alt" scale="0.65" class="text-external-link" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import CourseChart from '@/components/Charts/CourseChart'
import HideModalButton from '@/components/HideModalButton'
import { mapState } from 'vuex'
import {
  TOGGLE_MODAL_SCHOOL,
  TOGGLE_MODAL_RECAP_SCHOOL,
  CHANGE_SELECTED_TEACHER
} from '@/mutationTypes'

export default {
  name: 'modal-school',
  props: {
    onShowDistrictAreaClicked: Function,
    onTeacherClicked: Function,
    onCourseSelected: Function
  },
  components: {
    CourseChart,
    HideModalButton
  },
  created () {
    this.fetchStats()
  },
  computed: {
    ...mapState(['selectedProvince', 'selectedDistrict', 'selectedZone', 'selectedSchool', 'disabledTeacher']),
    province () {
      return this.selectedProvince || { nama: '' }
    },
    district () {
      return this.selectedDistrict || { nama_kabkota: '' }
    },
    zone () {
      return this.selectedZone || { kode_zonasi: '' }
    },
    school () {
      return this.selectedSchool || { properties: { nama: '' } }
    },
    isLogin () {
      return this.$store.getters.isLogin
    }
  },
  watch: {
    selectedSchool () {
      this.fetchStats()
    },
    disabledTeacher () {
      this.disableTeacher()
    }
  },
  data () {
    return {
      isFetchingStats: false,
      isDataAvailable: false,
      stats: {
        chart: [],
        colors: {},
        teachers: []
      },
      teachers: [],
      course: '',
      selectedTeacherIndex: null,
      districtNames: ''
    }
  },
  methods: {
    async fetchStats () {
      this.districtNames = ''

      try {
        this.isFetchingStats = true
        this.teachers = []
        this.course = ''
        let response = await this.$http.get(process.env.VUE_APP_API_URL + '/api/simrasio/formasi/' + this.selectedSchool.properties.bentuk + '/sekolah/' + this.selectedSchool.properties.sekolah_id)
        this.isFetchingStats = false
        let json = response.data
        if (json.status === 200) {
          this.isDataAvailable = true
          this.stats = {
            chart: json.result.chart,
            colors: json.result.colors,
            teachers: json.result.teachers
          }
        } else {
          this.isDataAvailable = false
        }
      } catch (err) {
        // console.log(err)
        this.isDataAvailable = false
      }

      try {
        let response = await fetch(process.env.VUE_APP_API_URL + '/api/districtsByZone/' + this.selectedZone.zonasi_id)
        let json = await response.json()
        if (json.status) {
          this.districtNames = json.districts.map((district) => {
            return district.properties.nama_kabkota
          }).join(' - ')
        }
      } catch (err) {
        // console.log(err)
      }
    },
    onSelect (index) {
      this.selectedTeacherIndex = null
      this.teachers = this.stats.teachers[this.stats.chart[index + 1][0]]
      this.course = this.stats.chart[index + 1][0]
      let haveMoreTeacher = this.stats.chart[index + 1][1] + this.stats.chart[index + 1][2] > this.stats.chart[index + 1][5]
      this.onCourseSelected(haveMoreTeacher)
    },
    selectTeacher (teacher, index) {
      if (teacher.isMutation === false) {
        this.selectedTeacherIndex = index
        this.onTeacherClicked(teacher, this.course)
      }
      this.$store.dispatch(CHANGE_SELECTED_TEACHER, {
        selectedTeacher: teacher,
        selectedCourse: this.course
      })
    },
    onClickHide () {
      this.$store.dispatch(TOGGLE_MODAL_SCHOOL, false)
    },
    showRecap () {
      this.$store.dispatch(TOGGLE_MODAL_RECAP_SCHOOL, true)
    },
    disableTeacher () {
      let index = this.teachers.findIndex((teacher) => {
        return teacher.nik === this.disabledTeacher.nik || teacher.nuptk === this.disabledTeacher.nuptk
      })
      if (index !== -1) {
        let newTeacher = this.teachers[index]
        newTeacher.isMutation = true
        this.selectedTeacherIndex = null
        this.$set(this.teachers, index, newTeacher)
      }
    }
  }
}
</script>

<style scoped>
@tailwind preflight;

.selected-teacher {
  @apply bg-brand-light
}

@tailwind utilities;
</style>
